import { Box } from "@mui/material";
import Modal from '@mui/material/Modal';
import { ImageSlider } from "../ImageSlider";
import { ComponentFile } from "../../context/ComponentBriefingContextProvider";

interface modalImageProps {
    open: boolean,
    images: ComponentFile[],
    onClose: (close: boolean) => void
}

export function ModalImage({ open, images, onClose }: modalImageProps) {
    return (
        <Modal
            open={open}
            onClose={onClose}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                width: '100vw',
                overflow: 'hidden'
            }}>
            <Box sx={{
                width: '60vw',
                height: '80vh',
                overflow: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 4
            }}>
                <ImageSlider images={images} onClose={onClose} />
            </Box>
        </Modal>
    )
}
